import React, { useState } from 'react';
import { LogOut, ChevronDown, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AdminNavbar = ({ setAuthToken }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  // Retrieve the saved user info (with fallbacks just in case)
  const userName = localStorage.getItem('userName') || 'Team Member';
  const userRole = localStorage.getItem('userRole') || 'Staff';

  const handleLogout = () => {
    // Clear everything out to securely log out
    setAuthToken(null);
    localStorage.removeItem('userName');
    localStorage.removeItem('userRole');
    navigate('/admin/login');
  };

  return (
    <div className="bg-brand-dark text-white py-4 px-8 flex justify-between items-center shadow-lg fixed w-full z-50 top-0">
      <div className="font-heading font-black text-xl flex items-center gap-2">
        A2Z <span className="text-brand-cyan">Portal</span>
      </div>
      
      <div className="relative">
        <button 
          onClick={() => setIsOpen(!isOpen)} 
          className="flex items-center gap-3 hover:text-brand-cyan transition-colors"
        >
          {/* New Profile Text Block */}
          <div className="text-right hidden md:block">
            <div className="text-sm font-bold text-white">{userName}</div>
            <div className="text-xs text-brand-cyan font-black uppercase tracking-widest">{userRole}</div>
          </div>
          
          <div className="w-10 h-10 bg-brand-cyan text-brand-dark rounded-full flex items-center justify-center font-bold shadow-md border-2 border-transparent hover:border-white transition-all">
            <User size={20} />
          </div>
          <ChevronDown size={16} className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
        </button>

        {isOpen && (
          <div className="absolute right-0 mt-3 w-56 bg-white rounded-xl shadow-2xl py-2 border border-gray-100 text-gray-800">
            <div className="px-4 py-3 border-b border-gray-50 md:hidden">
              <div className="text-sm font-bold text-brand-dark">{userName}</div>
              <div className="text-xs text-brand-cyan font-black uppercase tracking-widest">{userRole}</div>
            </div>
            <button 
              onClick={handleLogout} 
              className="w-full text-left px-4 py-3 hover:bg-red-50 flex items-center gap-3 text-red-600 font-bold transition-colors mt-1"
            >
              <LogOut size={18} /> Secure Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminNavbar;